const USER_SUBSCRIPTION_STATE = {
  LOGGED_OUT: 'logged_out',
  FREE: 'free',
  ESSENTIALS_ACTIVE: 'essentials_active',
  ESSENTIALS_CANCELLED: 'essentials_cancelled',
  PREMIUM: 'premium',
}

const deriveUserSubscriptionState = ({
  isLoggedIn, isActiveSubscriber, subscriptionTier, subscriptionScheduledForCancellation,
}) => {
  if (!isLoggedIn) return USER_SUBSCRIPTION_STATE.LOGGED_OUT
  if (!isActiveSubscriber) return USER_SUBSCRIPTION_STATE.FREE
  if (subscriptionTier === 'premium') return USER_SUBSCRIPTION_STATE.PREMIUM

  return subscriptionScheduledForCancellation
    ? USER_SUBSCRIPTION_STATE.ESSENTIALS_CANCELLED
    : USER_SUBSCRIPTION_STATE.ESSENTIALS_ACTIVE
}

export { USER_SUBSCRIPTION_STATE }

export default deriveUserSubscriptionState
